import React from 'react';
import { BrowserRouter as Router, Routes, Route, Navigate } from 'react-router-dom';
import Login from './components/Login';
import LicenseList from './components/LicenseList';
import LicenseForm from './components/LicenseForm';
import PrivateRoute from './components/PrivateRoute';
import './App.css';

function App() {
  return (
    <Router>
      <div className="App">
        <Routes>
          <Route path="/login" element={<Login />} />
          
          <Route
            path="/licenses"
            element={
              <PrivateRoute>
                <LicenseList />
              </PrivateRoute>
            }
          />
          
          <Route
            path="/licenses/new"
            element={
              <PrivateRoute>
                <LicenseForm />
              </PrivateRoute>
            }
          />
          
          <Route
            path="/licenses/:id"
            element={
              <PrivateRoute>
                <LicenseForm />
              </PrivateRoute>
            }
          />
          
          <Route path="/" element={<Navigate to="/licenses" />} />
          <Route path="*" element={<Navigate to="/licenses" />} />
        </Routes>
      </div>
    </Router>
  );
}

export default App;
